import { deleteApiGalaxyServer } from 'services';
import ApiClientManager from 'core/apiClient';
import { HardDeleteParams, HardDeleteResponse } from 'IntegrationModule/types';

export const deleteIntegrationApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<HardDeleteParams>) => {
  const customHeaders =
    params.tenant && params.realmId
      ? ApiClientManager.buildUrlHeaders({ tenantName: params.tenant, realmId: params.realmId })
      : undefined;

  const { tenant: _tenant, realmId: _realmId, targetServiceId, ...bodyParams } = params;

  return deleteApiGalaxyServer<
    Omit<HardDeleteParams, 'tenant' | 'realmId' | 'targetServiceId'>,
    HardDeleteResponse
  >(
    `/integrations_api/integrations/${targetServiceId}`,
    bodyParams,
    { ...config, ...(customHeaders && { headers: customHeaders }) },
    token,
  );
};
